// Explain saved match flags without changing or performing official grading.
function fireballMatchExplanation(match){
 const result=match?.result,flags=match?.evidence;
 if(!flags||!/^\d{3}$/.test(result?.main)||!/^\d$/.test(result?.fireball)||!/^\d{3}$/.test(match?.selection))return null;
 const family=s=>s.split('').sort().join('');
 for(const [flag,label] of [['fireballStraight','the same order'],['fireballBoxOnly','any order']]){
  if(flags[flag]!==true)continue;
  for(let i=0;i<3;i++){const changed=result.main.slice(0,i)+result.fireball+result.main.slice(i+1);if(flag==='fireballStraight'?changed===match.selection:family(changed)===family(match.selection))return `Fireball ${result.fireball} turns ${result.main} into ${changed}, matching ${match.selection} in ${label}.`;}
 }
 return null;
}
module.exports={fireballMatchExplanation};
